export default __webpack_public_path__ + "static/media/seamless-paw-bg.33c86274.png";